import { createGlobalStyle } from 'styled-components';
import useUIContext from '~/ui/use-ui-context';

export const BiggerGlobalStyle = createGlobalStyle`
	body {
		overflow-x: hidden;
		scrollbar-width: none;
		&::-webkit-scrollbar {
      display: none;
    }
		// Fix for right scroll bar offset on desktop
		.desktop-scrollbar > div {
			margin-right: 0px !important;
		}
		.desktop-scrollbar > div::-webkit-scrollbar {
			width: 0px;
			height: 0px;
			background-color: transparent;
		}
	}
`;

const GlobalStyleStyled = createGlobalStyle`
	body {
		height:  ${({ uiContext }) => (uiContext.showSidebar || uiContext.showOverlay ? '100%' : 'auto')};
	}
	html, body {
		overflow: ${({ uiContext }) => (uiContext.showSidebar || uiContext.showOverlay ? 'hidden' : 'visible')};
	}
`;

export const GlobalStyle = props => {
	const uiContext = useUIContext();
	return <GlobalStyleStyled {...props} uiContext={uiContext} />;
};
